import { render, staticRenderFns } from "./ListItemLpuSort.vue?vue&type=template&id=0001ac6e&scoped=true&"
import script from "./ListItemLpuSort.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemLpuSort.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ListItemLpuSort.vue?vue&type=style&index=0&id=0001ac6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0001ac6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0001ac6e')) {
      api.createRecord('0001ac6e', component.options)
    } else {
      api.reload('0001ac6e', component.options)
    }
    module.hot.accept("./ListItemLpuSort.vue?vue&type=template&id=0001ac6e&scoped=true&", function () {
      api.rerender('0001ac6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemLpuSort/ListItemLpuSort.vue"
export default component.exports